import Vue from 'vue'
import Vuex from 'vuex'

//import DataAccess from '@/libraries/DataAccess';
import contacts from '@/modules/contact';
import property from '@/modules/property';
import hydro from '@/modules/hydro';
import participationagreement from '@/modules/participationagreement';
import participant from '@/modules/participantinfo';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        accountType: "",
        hasAccount: false,
        summaryPage: false,
        signature: {
            name: "",
            date: "",
            jobTitle: "",
        },
    },
    getters: {
        TEST: state => {
            return state.test;
        },
        ACCOUNTTYPE: state => {
            return state.accountType;
        },
        HASACCOUNT: state => {
            return state.hasAccount;
        },
        SUMMARYPAGE: state => {
            return state.summaryPage;
        },
        SIGNATURE: state => {
            return state.signature;
        }
    },
    mutations: {
        SET_ACCOUNTTYPE: (state, value) => {
            state.accountType = value;
        },
        SET_HASACCOUNT: (state, value) => {
            state.hasAccount = value;
        },
        SET_SUMMARYPAGE: (state, value) => {
            state.summaryPage = value;
        },
        SET_SIGNATURE: (state, value) => {
            state.signature.name = value.name;
            state.signature.jobTitle = value.jobTitle;
            state.signature.date = value.date;
        },
    },

    actions: {
        SAVE_ACCOUNTTYPE: async (context, value) => {
            context.commit("SET_ACCOUNTTYPE", value);
        },
        SAVE_HASACCOUNT: async (context, value) => {
            context.commit("SET_HASACCOUNT", value);
        },
        SAVE_SUMMARYPAGE: async (context, value) => {
            context.commit("SET_SUMMARYPAGE", value);
        }
    },

    modules: {
        contacts, property, hydro, participationagreement,
        participant
    }
})

//export default new Vuex.Store({
//    state: {
//        contact: [{
//            "question": '',
//            "answer": ''
//        }],
//    },
//    getters: {
//        CONTACT: state => {
//            return state.contact;
//        }
//    },
//    mutations: {
//        SET_CONTACT: (state, contact) => {
//            state.contact = contact;
//        },
//        ADD_CONTACT: (state, contact) => {
//            state.contact.push(contact);
//        }
//    },
//    actions: {
//        GET_CONTACT: async (context) => {
//            let url = "http://cowmapdev/property/api/excel?sheetName=SheetA";

//            let data = await DataAccess.getResults(url);
            
//            let contacts = [];

//            if (data) {
//                for (let i = 0; i < data.length; i++) {
//                    contacts.push({ question: data[i][0], answer: "" });
//                }

//                context.commit("SET_CONTACT", contacts);
//            }
//        },
//        SAVE_CONTACT: async (context, contact) => {
//            // save contact info

//            context.commit("ADD_CONTACT", contact);
//        },
//    }
//})

//export default new Vuex.Store({
//    state: {},
//    getters: {},
//    mutations: {},
//    actions: {},

//    modules: {
//        contacts
//    }
    //state: {
    //    contact: {
    //        question: '',
    //        answer: ''
    //    },
    //    propertyInfo: {
    //        question: '',
    //        answer: ''
    //    },
    //    propertyDetail: {
    //        question: '',
    //        answer: ''
    //    },
    //    datareader: false,
    //    returnjson: {
    //        propertyinfo: {},
    //        propertydetail: [],
    //        propertydetailcount: 0
    //    },
    //},
    //getters: {
    //    CONTACT: state => {
    //        return state.contact;
    //    }
    //},
    //mutations: {
    //    SET_CONTACT: (state, contact) => {
    //        state.contact = contact;
    //    },
    //    ADD_CONTACT: (state, contact) => {
    //        state.contact.push(contact);
    //    }
    //},
    //actions: {
    //    GET_CONTACT: async (context, contact) => {
    //        let url = "http://cowmapdev/property/api/excel?sheetName=SheetA";

    //        let { data } = await DataAccess.getResults(url);

    //        if (data.length) {
    //            for (let i = 0; i < data.length; i++) {
    //                contact[i].question = data[i][0];
    //            }

    //            context.commit("SET_CONTACT", contact);
    //        }            
    //    },
    //    SAVE_CONTACT: async (context, contact) => {
    //        // save contact info

    //        context.commit("ADD_CONTACT", contact);
    //    },
    //    async getContact() {
    //        let url = "http://cowmapdev/property/api/excel?sheetName=SheetA";

    //        let { data } = await DataAccess.getResults(url);
    //        if (data.length) {
    //            //this.state.contact = data;

    //            for (let i = 0; i < data.length; i++) {  
    //                this.contact[i].question = data[i][0];
    //                //for (let j = 0; j < data[i].length; j++) {
    //                //    this.state.returnjson.propertyinfo[data[i][j]] = "";
    //                //}
    //            }
                
    //        }
    //    },
    //    async getPropertyInfo() {
    //        let url = "http://cowmapdev/property/api/excel?sheetName=Sheet1";

    //        const data = await DataAccess.getResults(url);
    //        if (data.length) {
    //            this.state.propertyInfo = data;
    //        }
    //    },
    //    async getPropertyDetail() {
    //        let url = "http://cowmapdev/property/api/excel?sheetName=SheetB";

    //        const data = await DataAccess.getResults(url);
    //        if (data.length) {
    //            this.state.propertyDetail = data;
    //        }
    //    }
    //},
    //modules: {
    //}
//})
